import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppConfig } from './constants';

@Injectable()
export class UsersService {
  private apiUrl = this.appConfig.API_URL_WEB;

  private headers = {headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })};

  constructor(public http: HttpClient, private appConfig: AppConfig) {

  }



  createHeader(tmpToken : any ) {

    let token = localStorage.getItem('G13xTfsdf234TVsd23513ffdgFdf2352');
    this.headers = {headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': token
    })};// , 'token': token
  }


  getUsers(token) {
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.get(this.apiUrl+'Usuarios', this.headers).subscribe(data => {
        resolve(data);
      }, err => {
        reject(err);
      });
    });
  }


  getUser(id, token) {
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.get(this.apiUrl+'Usuarios/'+id, this.headers).subscribe(data => {
        resolve(data);
      }, err => {
        reject(err);
      });
    });
  }

  newUser(params, token){
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.post(this.apiUrl+'Usuarios', params, this.headers)
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  updateUser(id, params, token){
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.put(this.apiUrl+'Usuarios/'+id, params, this.headers)
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  statusUser(id, params, userId, token){
    this.createHeader(token);
    return new Promise((resolve, reject) => {
//      this.http.put(this.apiUrl+'user/'+userId+'/users/'+id+'/status', params, this.headers)
      this.http.post(this.apiUrl+'Usuarios/'+userId+'/Status', params, this.headers)
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  changePasswordUser(id, params, token){
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.post(this.apiUrl+'Usuarios/'+id+'/ResetPassword', params, this.headers)
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  changePassword(id, params, token){
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.post(this.apiUrl+'Usuarios/'+id+'/CambiarPassword', params, this.headers)
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }


  completeInfo(params, userId, token){
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.post(this.apiUrl+'Usuarios/'+userId+'/ActualizarDatos', params, this.headers)
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  updateInfo(params, userId, token){
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.post(this.apiUrl+'Usuarios/'+userId+'/ActualizarDatosProveedor', params, this.headers)
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }
}
